import { Box, Flex, Title, Text } from '@mantine/core';
import MainItem from './MainItem';

interface CategorySectionProps {
  category?: {
    name: string;
    description?: string;
    uuid: string;
  };
  items: string[];
  isMobile: boolean;
  categoryRef: React.Ref<HTMLDivElement>;
}

export default function CategorySection({
  category,
  items,
  isMobile,
  categoryRef,
}: CategorySectionProps) {
  if (!category || items.length === 0) return null;

  const { name, description } = category;

  return (
    <Box ref={categoryRef} px={{ sm: 'md', md: 'xl' }} mt="xl">
      <Title order={5}>{name}</Title>
      <Text variant="body-sm" mt="xs2" mb="md">
        {description}
      </Text>
      <Flex direction="row" wrap="wrap" justify={{ base: 'center', maxTablet: 'space-between' }}>
        {items.map((itemID, index) => {
          const isFirstItem = index === 0;
          const isSecondItem = index === 1;
          const shouldHaveBorderTop = isMobile ? index === 0 : isFirstItem || isSecondItem;

          return (
            <Box
              h={{ base: 128, maxTablet: 152 }}
              key={itemID}
              style={{
                borderBottom: '1px solid var(--border-secondary)',
                borderTop: shouldHaveBorderTop ? '1px solid var(--border-secondary)' : 'none',
              }}
              w={{ base: '100%', maxTablet: 'calc(50% - 20px)' }}
            >
              <MainItem mainItem={itemID} isMobile={isMobile} />
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
}
